import * as types from '../constants/ActionTypes-privilegeElement';

// Definir el estado inicial
const initialState = {
  itemElement: {}, // Inicialmente vacío
  loading: false,
  error: null,
};

// Definir el reducer
const privilegeElementReducer = (state = initialState, action) => {
    if (action.reducer_type === 'reducer_privilege') {    
        switch (action.type) {
            case types.SET_ELEMENT:
                return {
                    ...state,
                    itemElement: action.payload,
                    loading: false,
                    error: null
                };                    
        }
    }
    return state;
};

export default privilegeElementReducer;